import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';

import PromoCode from '../../ViewListing/PromoCode/PromoCode';

import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect } from 'react-redux';
import { change } from 'redux-form';

// Component
import CurrencyConverter from '../../CurrencyConverter';
import ToolTipSection from '../../Common/ToolTipSection/ToolTipSection';
import OptionLines from '../../ListingOptions/OptionLines';

// Locale
import messages from '../../../locale/jsonMessages';

//Images
import { CouponCodeCloseSvg } from '../../Common/Assets/SvgIconComponent/CommonSvgIcon';
import { formatLocaleData } from '../../../helpers/formatLocale';

import cs from '../../commonStyle.css';
import s from './Payment.css';



class PaymentDetails extends Component {
  static propTypes = {
    options: PropTypes.array,
    currency: PropTypes.string.isRequired,
    dayDifference: PropTypes.number.isRequired,
    discount: PropTypes.number,
    discountType: PropTypes.string,
    priceForDays: PropTypes.number.isRequired,
    serviceFees: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
    formatMessage: PropTypes.any,
    isSpecialPriceAssigned: PropTypes.bool,
  };

  static defaultProps = {
    isSpecialPriceAssigned: false,
  };

  removePromo = () => {
    const { change } = this.props;
    change("PaymentForm", 'promoId', null);
    change("PaymentForm", 'promoValue', 0);
    change("PaymentForm", 'promoCode', null);
    change("PaymentForm", 'promoDiscount', 0);
    change("PaymentForm", 'deductionType', 0);
    change("BookingForm", 'promoId', null);
    change("BookingForm", 'promoValue', 0);
    change("BookingForm", 'promoCode', null);
    change("BookingForm", 'promoDiscount', 0);
    change("BookingForm", 'deductionType', 0);
    change("PaymentForm", 'editPayment', false);
    change("PaymentForm", 'description', null)
  }
  render() {
    const { options, currency, dayDifference, securityDeposit } = this.props;
    const { priceForDays, serviceFees, discount, discountType, total } = this.props;
    const { formatMessage, locale } = this.props.intl;
    const { isSpecialPriceAssigned, isAverage, securityDepositStatus } = this.props;
    const { promoCode, promoDiscount, description, isPromoCodeEnabled, promoCodeLoading, dynamicPromoCode } = this.props;
    const dynamicValue = dynamicPromoCode && dynamicPromoCode.find(item => item.language === formatLocaleData(locale));

    return (
      <div>
        <div className={cx(cs.dataTableGrid, cs.paymentDivider)}>
          <div className={cx(cs.commonSmallText16, cs.textStart)}>
            <div className='tooltipFlex'>
              {isSpecialPriceAssigned && <ToolTipSection label={formatMessage(messages.averageRate)}
                tooltipIconClass={cx(cs.positionRelative, cs.top3)} />}
              <div>
                <CurrencyConverter amount={isAverage} from={currency} />
                <span className={cs.displayinlineBlock}>&nbsp;{'x'}&nbsp;&rlm;{dayDifference} {dayDifference > 1 ? formatMessage(messages.nights) : formatMessage(messages.night)}</span>
              </div>
            </div>
          </div>

          <div className={cx(cs.commonSmallText16, cs.textEnd)}>
            <CurrencyConverter amount={priceForDays} from={currency} />
          </div>
        </div>

        {
          discount > 0 &&
          <div className={cx(cs.dataTableGrid, cs.paymentDivider, 'discountText')}>
            <div className={cx(cs.commonSmallText16, cs.textStart)}>{discountType}</div>
            <div className={cx(cs.commonSmallText16, cs.textEnd)}>
              <span>-&nbsp; <CurrencyConverter amount={discount} from={currency} /></span>
            </div>
          </div>
        }

        {
          promoDiscount > 0 && <div className={cx(cs.dataTableGrid, cs.paymentDivider)}>
            <div className={cx(cs.commonSmallText16, cs.textStart)}>
              <div className="tooltipFlex">
                <ToolTipSection label={dynamicValue ? dynamicValue?.description : description} tooltipIconClass={cx(cs.positionRelative, cs.top3)} />
                <span className='discountText'>{promoCode}</span>
                <CouponCodeCloseSvg className={cx(cs.positionRelative, cs.top2, 'couponCodeCloseIcon')}
                  onClick={() => this.removePromo()} />
              </div>
            </div>

            <div className={cx(cs.commonSmallText16, cs.textEnd, 'discountText')}>
              <span>-&nbsp;  <CurrencyConverter amount={promoDiscount} from={currency} /> </span>
            </div>
          </div>
        }
        {
          options && options.length > 0 && (discount > 0 || promoDiscount > 0) &&
          <div className={cx(cs.dataTableGrid, cs.paymentDivider)}>
            <div className={cx(cs.commonSmallText16, cs.fontWeightMedium, cs.textStart)}><FormattedMessage {...messages.boSubtotalVehicle} /></div>
            <div className={cx(cs.commonSmallText16, cs.fontWeightMedium, cs.textEnd)}>
              <CurrencyConverter amount={priceForDays - (discount || 0) - (promoDiscount || 0)} from={currency} />
            </div>
          </div>
        }
        <OptionLines lines={options} currency={currency} showLocation />
        {
          serviceFees > 0 &&
          <div className={cx(cs.dataTableGrid, cs.paymentDivider)}>
            <div className={cx(cs.commonSmallText16, cs.textStart)}><FormattedMessage {...messages.serviceFee} /></div>
            <div className={cx(cs.commonSmallText16, cs.textEnd)}>
              <CurrencyConverter amount={serviceFees} from={currency} />
            </div>
          </div>
        }
        {
          securityDeposit > 0 && securityDepositStatus == 1 &&
          <div className={cx(cs.dataTableGrid, cs.paymentDivider)}>
            <div className={cx(cs.commonSmallText16, cs.textStart)}><FormattedMessage {...messages.securityDeposit} /></div>
            <div className={cx(cs.commonSmallText16, cs.textEnd)}>
              <CurrencyConverter amount={securityDeposit} from={currency} />
            </div>
          </div>
        }

        {(!promoDiscount || promoDiscount <= 0) && isPromoCodeEnabled == "true" &&
          <PromoCode
            containerClass={cs.paymentDivider}
            promoCodeLoading={promoCodeLoading}
            discount={discount}
          />}

        <div className={cs.dataTableGrid}>
          <div className={cx(cs.commonSmallText16, cs.fontWeightMedium, cs.textStart)}><FormattedMessage {...messages.total} /></div>
          <div className={cx(cs.commonSmallText16, cs.fontWeightMedium, cs.textEnd)}>
            <CurrencyConverter amount={total} from={currency} />
          </div>
        </div>
      </div>
    );
  }
}


const mapState = (state) => ({
  isPromoCodeEnabled: state?.siteSettings?.data?.isPromoCodeEnabled,
  promoCodeLoading: state?.book?.promoCodeLoading
});

const mapDispatch = {
  change
};


export default injectIntl(withStyles(cs, s)(connect(mapState, mapDispatch)(PaymentDetails)));